<div class="pdf-viewer-container">
  @if (pdfUrl()) {
    <div class="viewer-wrapper">
      @if (!isLoaded()) {
        <div
          class="pdf-viewer-loader loading-container"
          aria-busy="true"
          [attr.aria-label]="'learningPathway.PDF_LOADING' | transloco"
        >
          <qai-loading [size]="'medium'"></qai-loading>
        </div>
      }
      <div class="viewer-area">
        <!-- pdfViewerKey forces destroy+recreate of pdf-viewer on each new URL,
             preventing stale scroll mode, scale, and visibility state when two
             consecutive pathway steps are both PDF type. -->
        @for (_ of [pdfViewerKey()]; track _) {
          <pdf-viewer
            [src]="pdfUrl()"
            [customScale]="customPdfScale()"
            (pageDimensions)="onPageDimensions($event)"
            (pagesLoaded)="onPagesLoaded($event)"
            (pageChange)="onPageChange($event)"
            (pageRendered)="onPageRendered()"
            (beyondPageWidth)="onBeyondPageWidth($event)"
            (isScrollable)="onIsScrollable($event)"
            (firstScrolled)="onFirstScrolled()"
          />
        }
      </div>
      @if (showScrollHint) {
        <div class="scroll-hint" aria-live="polite">
          {{ 'learningPathway.PDF_SCROLL_HINT' | transloco }}
        </div>
      }
      @if (!isZoomedBeyondPageWidth() && totalPages() > 1) {
        <button
          qai-button
          type="button"
          [shape]="'circle'"
          [kind]="'tertiary'"
          [size]="'small'"
          [disabled]="!canGoPrevious"
          (click)="previousPage()"
          class="nav-button nav-left"
          [attr.aria-label]="'learningPathway.PDF_PREVIOUS_PAGE' | transloco"
        >
          <qai-icon kind="chevron-left" positionStart />
        </button>
        <button
          qai-button
          type="button"
          [shape]="'circle'"
          [kind]="'tertiary'"
          [size]="'small'"
          [disabled]="!canGoNext"
          (click)="nextPage()"
          class="nav-button nav-right"
          [attr.aria-label]="'learningPathway.PDF_NEXT_PAGE' | transloco"
        >
          <qai-icon kind="chevron-right" positionStart />
        </button>
      }

      <div class="pdf-controls" [class.visible]="hasPageRendered()">
        <button
          qai-button
          type="button"
          [shape]="'circle'"
          [kind]="'tertiary'"
          [size]="'medium'"
          (click)="toggleFullscreen()"
          [attr.aria-label]="(isFullscreen() ? 'learningPathway.PDF_FULLSCREEN_EXIT' : 'learningPathway.PDF_FULLSCREEN_ENTER') | transloco"
        >
          <qai-icon [kind]="isFullscreen() ? 'minimize' : 'expand'" positionStart />
        </button>
        <button
          qai-button
          type="button"
          [shape]="'circle'"
          [kind]="'tertiary'"
          [size]="'medium'"
          [disabled]="!canZoomOut"
          (click)="zoomOut()"
          [attr.aria-label]="'learningPathway.PDF_ZOOM_OUT' | transloco"
        >
          <qai-icon kind="zoom-out" positionStart />
        </button>
        <button
          qai-button
          type="button"
          [shape]="'circle'"
          [kind]="'tertiary'"
          [size]="'medium'"
          [disabled]="!canZoomIn"
          (click)="zoomIn()"
          [attr.aria-label]="'learningPathway.PDF_ZOOM_IN' | transloco"
        >
          <qai-icon kind="zoom-in" positionStart />
        </button>
        @if (totalPages() > 1) {
          <qai-page-indicator
            class="page-indicator"
            [currentPage]="currentPage()"
            [totalPages]="totalPages() || 0"
            aria-live="polite"
          />
        }
      </div>
    </div>
  } @else {
    <div class="pdf-viewer-empty">
      <p>{{ "learningPathway.PDF_NO_SOURCE" | transloco }}</p>
    </div>
  }
</div>
